// extracted by mini-css-extract-plugin
export default {"blockHover":"MainRouter_blockHover__PRUEx"};